import $ from 'jquery';
import TomSelect from 'tom-select/dist/js/tom-select.complete.min.js';

let fieldsAreInitialized = false;

function changeFileUpload() {
  const multiFileUploads = document.querySelectorAll(
    '.gform_fileupload_multifile'
  );
  if (0 < multiFileUploads.length) {
    multiFileUploads.forEach(function (fileUpload) {
      fileUpload.querySelector('.gform_drop_instructions').textContent =
        wp.i18n._x(
          'Drag and drop file to upload',
          'drag and drop instruction',
          'vtx'
        );
    });
  }
}

// Replace native Gravity Forms dropdowns with Tom Select so the options panel
// renders below the field and matches the styled `.ts-dropdown` design.
function enhanceSelects() {
  const selects = document.querySelectorAll(
    '.gform_wrapper select:not([multiple])'
  );
  selects.forEach(function (select) {
    if (select.tomselect) {
      return;
    }
    // eslint-disable-next-line no-new
    new TomSelect(select, {
      controlInput: null, // no search box — behaves like a styled native select
    });
  });
}

$(document).on('gform_post_render', function () {
  fieldsAreInitialized = true;
  changeFileUpload();
  enhanceSelects();
});

// ON READY
window.addEventListener('load', function () {
  if (!fieldsAreInitialized) {
    changeFileUpload();
    enhanceSelects();
  }
});
